import { Scene } from 'three'
import EventEmitter from './Utils/EventEmitter.js'
import UI from "./UI/UI.js";
import Sizes from "./Utils/Sizes.js";
import Time from "./Utils/Time.js";
import Camera from "./Camera.js";
import Renderer from "./Renderer.js";
import Resources from "./Utils/Resources.js";
import sources from './sources.js'
import World from "./World/World.js";
import Input from "./Utils/Input.js";

export default class Experience extends EventEmitter {
    static _instance = null;

    static getInstance() {
        return Experience._instance || new Experience();
    }
    constructor(parent) {
        super();

        this.parent = parent || document;

        if (Experience._instance) {
            return Experience._instance;
        }

        Experience._instance = this;

        window.experience = this;

        this.initResources();
        this.init();
    }

    initDesktop() {
        this.scene = new Scene();
        this.camera = new Camera();
        this.renderer = new Renderer();
        this.input = new Input();
        this.world = new World();
    }

    initMobile() {
        this.scene = new Scene();
        this.camera = new Camera();
        this.renderer = new Renderer();
        this.input = new Input();
        this.world = new World();
    }

    initResources() {
        this.resources = new Resources( sources )
    }

    init() {
        this.ui = new UI(this.parent);
        this.sizes = new Sizes();
        this.time = new Time();

        if (this.sizes.isMobile) {
            this.initMobile()
        } else {
            this.initDesktop()
        }

        this.setListeners()

        this.trigger('classesReady')
    }

    resize() {
        this.camera.resize()
        this.world.resize()
        this.renderer.resize()

        // if(!this.size.isMobile) {
        //     this.camera.resize()
        //     this.world.resize()
        //     this.renderer.resize()
        // }
    }

    update() {
        this.world.update( this.time.delta )
        this.ui.update( this.time.current )
        this.renderer.update( this.time.delta )
    }

    updateMobile() {
        this.world.update( this.time.delta )
        this.ui.update( this.time.current )
        this.renderer.update( this.time.delta )
    }

    setListeners() {
        // Resize event
        this.sizes.on( 'resize', () => {
            this.resize()
        } )

        // Time tick event
        this.time.on( 'tick', () => {
            this.sizes.isMobile ? this.updateMobile() : this.update()
        } )

        this.resources.on( 'ready', () => {
            this.ui.hidePreloader()
            setTimeout( () => {
                window.scroller.update()
            }, 500)
        })

    }

    destroy() {
        this.ui.destroy()
        this.camera.destroy()
        this.renderer.destroy()
        this.world.destroy()
    }
}
